import { render, staticRenderFns } from "./ExportacaoProtheus.vue?vue&type=template&id=1a2d0409"
import script from "./ExportacaoProtheus.vue?vue&type=script&lang=js"
export * from "./ExportacaoProtheus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports